import { icons, backgroundColors } from "./assets";

//DOM element cache
let selectedSubjectHeader = null;
let startMenuSection = null;
let questionsSection = null;
let scoreSection = null;

/**
 * Initiaqlizes DOM element preferences
 * Call this once when app starts
 */
export const initDOMElements = () => {
  selectedSubjectHeader = document.getElementById(
    "selected-quiz-subject-header",
  );
  startMenuSection = document.getElementById("start-menu-section");
  questionsSection = document.getElementById("questions-section");
  scoreSection = document.getElementById("score-section");
};

/**
 * Shows error message when no answer is selected
 */
export const showErrorMessage = () => {
  console.log("🔴 showErrorMessage called");
  const errorMessage = document.getElementById("error-message");
  console.log("errorMessage element:", errorMessage);
  console.log("Classes BEFORE:", errorMessage?.className);

  errorMessage.classList.remove("hidden");

  console.log("Classes AFTER:", errorMessage?.className);
};

/**
 * Hides error message
 */
export const hideErrorMessage = () => {
  console.log("✅ hideErrorMessage called");
  const errorMessage = document.getElementById("error-message");
  console.log("errorMessage element:", errorMessage);
  errorMessage.classList.add("hidden");
};

/**
 * Shows selected subject in the header
 */
export const showSelectedSubjectHeader = () => {
  selectedSubjectHeader.classList.remove("invisible");
};

/**
 * Hides selected subject in the header
 */
export const hideSelectedSubjectHeader = () => {
  selectedSubjectHeader.classList.add("invisible");
};

/**
 * Shows section by removing "hidden" class
 *
 * @param {string} sectionId - The section ID ("start-menu-section" e.g.)
 */
export const showSection = (sectionId) => {
  const sections = {
    "start-menu-section": startMenuSection,
    "questions-section": questionsSection,
    "score-section": scoreSection,
  };

  sections[sectionId]?.classList.remove("hidden");
};

/**
 * Hides section by adding "hidden" class
 * @param {string} sectionId  - The section ID ("start-menu-section" e.g.)
 */
export const hideSection = (sectionId) => {
  const sections = {
    "start-menu-section": startMenuSection,
    "questions-section": questionsSection,
    "score-section": scoreSection,
  };

  sections[sectionId]?.classList.add("hidden");
};

/**
 * Updates the header to show the selected quiz subject
 * @param {string} title - Quiz title (e.g., 'HTML', 'CSS')
 */
export const updateHeaderSubject = (title) => {
  const subjectIcon = selectedSubjectHeader.querySelector(
    ".selected-subject-icon",
  );
  const subjectTitle = selectedSubjectHeader.querySelector(
    ".selected-subject-title",
  );

  subjectIcon.src = icons[title];
  subjectTitle.textContent = title;

  //Update background color
  subjectIcon.classList.remove(
    "bg-orange-50",
    "bg-green-100",
    "bg-blue-50",
    "bg-purple-100",
  );

  const bgColor = backgroundColors[title];
  if (bgColor) {
    subjectIcon.classList.add(bgColor);
  }
};

/**
 * Render the current question and its options
 * @param {Object} question - Question object with text and option
 * @param {number} questionNumber - Current question number (1-based)
 * @param {number} totalQuestions - Total number of questions
 */
export const renderQuestion = (question, questionNumber, totalQuestions) => {
  // Update question number and text
  const questionNumberEl = document.getElementById("question-number-of");
  questionNumberEl.textContent = `Question ${questionNumber} of ${totalQuestions}`;

  const questionTextEl = document.getElementById("question-text");
  questionTextEl.textContent = question.question;

  // Update answer options
  const answerButtons = document.querySelectorAll('[role="radio"]');
  const answerLetters = ["A", "B", "C", "D"];

  answerButtons.forEach((button, index) => {
    const answerLetterSpan = button.querySelector(".answer-letter");
    const answerText = button.querySelector(".answer-text");

    answerLetterSpan.textContent = answerLetters[index];
    answerText.textContent = question.options[index];

    // Reset button state
    button.setAttribute("aria-checked", "false");
    button.classList.remove(
      "outline-2",
      "outline-purple-600",
      "outline-green-500",
      "outline-red-500",
    );

    //Reset letter background and text colors
    const letterContainer = button.querySelector(".answer-letter-container");
    letterContainer.classList.remove(
      "bg-purple-600",
      "bg-green-500",
      "bg-red-500",
    );
    letterContainer.classList.add("bg-grey-50");
    answerLetterSpan.classList.remove("text-white");
    answerLetterSpan.classList.add("text-grey-500");

    // Hide all icons
    const icons = button.querySelectorAll("img");
    icons.forEach((icon) => icon.classList.add("hidden"));
  });

  // Update progress bar
  updateProgressBar(questionNumber, totalQuestions);

  // Reset submit button
  updateSubmitButtonText("Submit Answer");
  hideErrorMessage();
};

/**
 * Updates progress bar
 * @param {number} current - Current question number (1- based)
 * @param {number} total - Total number of questions
 */
export const updateProgressBar = (current, total) => {
  const progressBar = document.querySelector("[role='progressbar']");
  const progressFill = document.getElementById("progress-fill");
  const percentage = (current / total) * 100;

  progressFill.style.width = `${percentage}%`;
  progressBar.setAttribute("aria-valuenow", Math.round(percentage));
  progressBar.setAttribute("aria-label", `${Math.round(percentage)}% Progress`);
};

/**
 * Highlights the selected answer button
 * @param {HTMLElement} button - The selected answer button
 */
export const highlightSelectedAnswer = (button) => {
  const allButtons = document.querySelectorAll('[role="radio"]');

  // Remove highlight from all buttons
  allButtons.forEach((btn) => {
    btn.setAttribute("aria-checked", "false");
    btn.classList.remove("outline-2", "outline-purple-600");

    // Reset letter background and text - inside το button
    const letterContainer = btn.querySelector(".answer-letter-container");
    const answerLetterSpan = btn.querySelector(".answer-letter");

    letterContainer.classList.remove("bg-purple-600");
    letterContainer.classList.add("bg-grey-50");
    answerLetterSpan.classList.remove("text-white");
    answerLetterSpan.classList.add("text-grey-500");
  });

  // Highlight selected button
  button.setAttribute("aria-checked", "true");
  button.classList.add("outline-2", "outline-purple-600");

  // Change letter background to purple - inside to selected button
  const letterContainer = button.querySelector(".answer-letter-container");
  const answerLetterSpan = button.querySelector(".answer-letter");

  letterContainer.classList.remove("bg-grey-50");
  letterContainer.classList.add("bg-purple-600");
  answerLetterSpan.classList.remove("text-grey-500");
  answerLetterSpan.classList.add("text-white");
};

/**
 *
 * @param {HTMLElement} selectButton - The button the user selected
 * @param {string} correctAnswer - The correct answer text
 * @param {boolean} isCorrect - Whether the user's answer was correct
 */
export const showAnswerFeedback = (
  selectedButton,
  correctAnswer,
  isCorrect,
) => {
  const allButtons = document.querySelectorAll('[role="radio"]');

  // Find the correct answer button
  let correctButton = null;
  allButtons.forEach((btn) => {
    const answerText = btn.querySelector(".answer-text").textContent;
    if (answerText === correctAnswer) {
      correctButton = btn;
    }
  });

  // Show correct answer styling
  if (correctButton) {
    correctButton.classList.remove("outline-purple-600");
    correctButton.classList.add("outline-2", "outline-green-500");

    // Change letter background to green
    const letterContainer = correctButton.querySelector(
      ".answer-letter-container",
    );
    const letterSpan = correctButton.querySelector(".answer-letter");
    letterContainer.classList.remove("bg-grey-50", "bg-purple-600");
    letterContainer.classList.add("bg-green-500");
    letterSpan.classList.add("text-white");

    // Show correct icon (first img)
    const correctIcon = correctButton.querySelectorAll("img")[0];
    correctIcon.classList.remove("hidden");
  }

  // If user was wrong, show error styling
  if (!isCorrect && selectedButton !== correctButton) {
    selectedButton.classList.remove("outline-purple-600");
    selectedButton.classList.add("outline-2", "outline-red-500");

    // Change letter background to red
    const letterContainer = selectedButton.querySelector(
      ".answer-letter-container",
    );
    const letterSpan = selectedButton.querySelector(".answer-letter");
    letterContainer.classList.remove("bg-grey-50", "bg-purple-600");
    letterContainer.classList.add("bg-red-500");
    letterSpan.classList.add("text-white");

    // Show error icon (second img)
    const errorIcon = selectedButton.querySelectorAll("img")[1];
    errorIcon.classList.remove("hidden");
  }
};

/**
 * Enables or disables the submit answer button
 * @param {boolean} enabled - Whether to enable the button
 */
export const toggleSubmitButton = (enabled) => {
  const submitButton = document.getElementById("submit-answer-button");
  submitButton.disabled = !enabled;
  submitButton.setAttribute("aria-disabled", String(!enabled));
};

/**
 * Changes submit button text (for "Submit Answer" vs "Next Question")
 * @param {string} text - The button text
 */
export const updateSubmitButtonText = (text) => {
  const submitButton = document.getElementById("submit-answer-button");
  const buttonText = submitButton.querySelector("span");
  buttonText.textContent = text;
};

/**
 * Renders the final score screen
 * @param {string} quizTitle - The quiz title
 * @param {string} quizIcon - Path to the quiz icon
 * @param {number} score - Number of correct answers
 * @param {number} totalQuestions - Total number of questions
 */
export const renderScoreScreen = (quizTitle, score, totalQuestions) => {
  // Update quiz subject in score section
  const subjectIcon = scoreSection.querySelector(".selected-subject-icon");
  const subjectTitle = scoreSection.querySelector(".selected-subject-title");

  subjectIcon.src = icons[quizTitle];
  subjectTitle.textContent = quizTitle;

  //Update background color
  subjectIcon.classList.remove(
    "bg-orange-50",
    "bg-green-100",
    "bg-blue-50",
    "bg-purple-100",
  );

  const bgColor = backgroundColors[quizTitle];
  if (bgColor) {
    subjectIcon.classList.add(bgColor);
  }

  // Update score numbers
  const scoreNumber = scoreSection.querySelector(".score-number");
  const totalText = scoreSection.querySelector(".out-of-total");

  scoreNumber.textContent = score;
  totalText.textContent = `out of ${totalQuestions}`;

  // Enable play again button
  const playAgainButton = document.getElementById("play-again-button");
  playAgainButton.disabled = false;
  playAgainButton.setAttribute("aria-disabled", "false");
};
